module.exports = __webpack_public_path__ + "static/img/slogin.d957667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobiigw/slogin.png
// module id = voPd
// module chunks = 1